export const SET_IS_DISCONNECTED = 'SET_IS_DISCONNECTED';

export const setIsDisconnected = (status) => ({
    type: SET_IS_DISCONNECTED,
    payload: status,
});